export default "__VITE_ASSET__4f2e05f3__"